import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { MessageSquare, Search, FileCheck, Key } from 'lucide-react';

const Journey = () => {
  const { t } = useLanguage();

  const steps = [
    {
      icon: MessageSquare,
      step: '01',
      title: t('journey.steps.consultation.title'),
      description: t('journey.steps.consultation.description')
    },
    {
      icon: Search,
      step: '02',
      title: t('journey.steps.selection.title'),
      description: t('journey.steps.selection.description')
    },
    {
      icon: FileCheck,
      step: '03',
      title: t('journey.steps.acquisition.title'),
      description: t('journey.steps.acquisition.description')
    },
    {
      icon: Key,
      step: '04',
      title: t('journey.steps.handover.title'),
      description: t('journey.steps.handover.description')
    }
  ];

  return (
    <section className="section-padding bg-[#1A1A2E]" data-testid="journey-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-[#C9A227] text-xs font-semibold tracking-[0.15em] uppercase mb-4">{t('journey.overline')}</p>
          <h2 className="font-playfair text-3xl sm:text-4xl lg:text-5xl text-white font-semibold">
            {t('journey.title')}
          </h2>
        </div>

        {/* Steps */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((item, index) => (
            <div
              key={index}
              className="relative bg-white/5 border border-white/10 rounded-2xl p-6 hover:border-[#C9A227]/30 transition-all group"
              data-testid={`journey-step-${index}`}
            >
              {/* Step Number */}
              <span className="absolute top-4 right-4 text-5xl font-playfair text-white/5 font-bold">
                {item.step}
              </span>

              {/* Icon */}
              <div className="w-14 h-14 rounded-2xl bg-[#C9A227]/10 border border-[#C9A227]/20 flex items-center justify-center mb-6 group-hover:bg-[#C9A227]/20 transition-colors">
                <item.icon className="w-6 h-6 text-[#C9A227]" />
              </div>

              {/* Content */}
              <h3 className="text-lg font-playfair text-white font-semibold mb-3">
                {item.title}
              </h3>
              
              <p className="text-white/60 text-sm leading-relaxed">
                {item.description}
              </p>

              {/* Connector Line (hidden on last item) */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-3 w-6 h-px bg-gradient-to-r from-[#C9A227]/50 to-transparent" />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Journey;
